module.exports = __webpack_public_path__ + "static/img/01_bildung_spw_plakatprasentation_304x204mm_.e6e395e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/01_bildung_spw_plakatprasentation_304x204mm_.jpg
// module id = 200
// module chunks = 1